module.exports = __webpack_public_path__ + "img/icon03.f9c6590e.png";